import { z } from 'zod';

/** Valeurs du formulaire « Où se situe le véhicule ? » (proposition Accimoto acceptée). */
export interface LocalisationVehiculeValues {
    name: string;
    address: string;
    postal_code: string;
    town: string;
}

/** Longueurs maximales des colonnes `A_LIEU_*` de `XACCIMOTO`. */
const MAX_LENGTHS: Record<keyof LocalisationVehiculeValues, number> = {
    name: 100,
    address: 255,
    postal_code: 5,
    town: 100,
};

export const localisationVehiculeSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Partial<Record<keyof LocalisationVehiculeValues, unknown>>;
    const errors: Partial<Record<keyof LocalisationVehiculeValues, string>> = {};

    for (const field of Object.keys(MAX_LENGTHS) as (keyof LocalisationVehiculeValues)[]) {
        const value = typeof v[field] === 'string' ? v[field].trim() : '';

        if (!value) {
            errors[field] = 'Le champ est obligatoire';
        } else if (value.length > MAX_LENGTHS[field]) {
            errors[field] = `Le champ ne doit pas dépasser ${MAX_LENGTHS[field]} caractères`;
        }
    }

    if (!errors.postal_code && !/^\d{5}$/.test(String(v.postal_code).trim())) {
        errors.postal_code = 'Le code postal doit comporter 5 chiffres';
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
